module.exports = __webpack_public_path__ + "img/delete.534235d9.svg";